import templateUrl from "./user-edit.html";

export const userEditComponent = {
  bindings: {
    title: "@",
    branchOfServiceList: "<",
    rankList: "<",
    statusList: "<",
    details: "<",
    disableButtons: "<",
  },
  templateUrl,
  controller: class userEditComponent {
    constructor(
      $state,
      $stateParams,
      $timeout,
      toastr,
      UserService,
      CompareObjectService,
      Constants,
      DateService,
      GoogleLocationService
    ) {
      "ngInject";

      this.$state = $state;
      this.$stateParams = $stateParams;
      this.$timeout = $timeout;
      this.toastr = toastr;
      this.constants = Constants;
      this.UserService = UserService;
      this.dateService = DateService;
      this.compareObjectService = CompareObjectService;
      this.googleLocationService = GoogleLocationService;
    }
    $onInit() {
      this.enrolledInSpecialPrograms = {
        enpp: null,
        jobCorps: null,
        skillbridge: null,
        etsSponsorship: null,
      };
      this.initializeGoogleAutocomplete();
      this.branchOfServiceList = this.branchOfServiceList.map((value) => ({
        id: value.batchServiceId,
        name: value.displayName,
      }));
      this.rankList = this.rankList.map((value) => ({
        id: value.rankId,
        name: value.displayName,
      }));
      this.statusList = this.statusList.map((value) => ({
        id: value.id,
        name: value.displayName,
      }));
      this.selectedStatusId =
        this.details &&
        this.details.status &&
        this.statusList.find((value) => value.name === this.details.status).id;

      this.disableInput = false;
      if (this.details.enrolledInSpecialPrograms) {
        if (this.details.enrolledInSpecialPrograms.enpp !== null) {
          this.enrolledInSpecialPrograms.enpp = this.getYesNoId(
            this.details.enrolledInSpecialPrograms.enpp
          );
        }
        if (this.details.enrolledInSpecialPrograms.jobCorps !== null) {
          this.enrolledInSpecialPrograms.jobCorps = this.getYesNoId(
            this.details.enrolledInSpecialPrograms.jobCorps
          );
        }
        if (this.details.enrolledInSpecialPrograms.skillbridge !== null) {
          this.enrolledInSpecialPrograms.skillbridge = this.getYesNoId(
            this.details.enrolledInSpecialPrograms.skillbridge
          );
        }
        if (this.details.enrolledInSpecialPrograms.etsSponsorship !== null) {
          this.enrolledInSpecialPrograms.etsSponsorship = this.getYesNoId(
            this.details.enrolledInSpecialPrograms.etsSponsorship
          );
        }
      }

      this.dob = {
        isRequired: true,
        disableFutureDates: true,
        selectedDate: this.details.dob,
      };
      this.startDateOfService = {
        isRequired: true,
        selectedDate: this.details.startDateOfService,
      };
      this.maritalStatus = [
        { id: 1, title: "Single" },
        { id: 2, title: "Married" },
      ];
      this.yesOrNoOptions = [
        { id: 1, title: "Yes" },
        { id: 2, title: "No" },
      ];
      this.selectedMaritalStatusId =
        this.details.maritalStatus === "single"
          ? 1
          : this.details.maritalStatus === "married"
          ? 2
          : null;

      this.phoneNumberDetails = {
        phoneNumber: this.details.phoneNumber,
        phoneCountryCode: this.details.phoneCountryCode,
        phoneDialCode: this.details.phoneDialCode,
      };
      if (this.details.currentLocation) {
        this.details.currentLocation.locationName = `${this.details.currentLocation.addressLine1}, ${this.details.currentLocation.stateCode}`;
      }
      if (this.details.currentLocation) {
        this.formattedCurrentLocation = `${this.details.currentLocation.cityName}, ${this.details.currentLocation.stateCode}`;
      }
    }
    initializeGoogleAutocomplete() {
      const input = document.getElementById("currentLocation");
      const autoComplete = new google.maps.places.Autocomplete(input, {
        types: ["(cities)"],
        country: ["us", "usa"],
        componentRestrictions: { country: "us" },
      });
      autoComplete.addListener(
        "place_changed",
        this.onChangeCurrentLocation.bind(this, autoComplete)
      );
    }
    getSpecialProgramsBooleanValue(enrolledInSpecialPrograms) {
      if (enrolledInSpecialPrograms.enpp !== null) {
        this.enrolledInSpecialPrograms.enpp = this.getYesNoBooleanValue(
          enrolledInSpecialPrograms.enpp
        );
      }
      if (enrolledInSpecialPrograms.jobCorps !== null) {
        this.enrolledInSpecialPrograms.jobCorps = this.getYesNoBooleanValue(
          enrolledInSpecialPrograms.jobCorps
        );
      }
      if (enrolledInSpecialPrograms.skillbridge !== null) {
        this.enrolledInSpecialPrograms.skillbridge = this.getYesNoBooleanValue(
          enrolledInSpecialPrograms.skillbridge
        );
      }
      if (enrolledInSpecialPrograms.etsSponsorship !== null) {
        this.enrolledInSpecialPrograms.etsSponsorship =
          this.getYesNoBooleanValue(enrolledInSpecialPrograms.etsSponsorship);
      }
      return this.enrolledInSpecialPrograms;
    }
    onChangeRank(rankId) {
      this.details.rankId = rankId;
    }
    onChangeStatus(statusId) {
      if (statusId) {
        const res =
          this.statusList &&
          this.statusList.find(
            (value) => parseInt(value.id) === parseInt(statusId)
          );
        this.details.status = res ? res.name : null;
      }
    }
    onChangeBranchOfService(batchServiceId) {
      this.details.batchServiceId = batchServiceId;
    }
    onChangeMaritalStatus(details) {
      this.selectedMaritalStatusId = parseInt(details.$event.id);
    }
    onChangeEnrolledInSkillBridgeOption(details) {
      this.enrolledInSpecialPrograms.skillbridge = parseInt(details.$event.id);
    }
    onChangeEnrolledInCMVROption(details) {
      this.enrolledInSpecialPrograms.jobCorps = parseInt(details.$event.id);
    }
    onChangeEnrolledInENPP(details) {
      this.enrolledInSpecialPrograms.enpp = parseInt(details.$event.id);
    }
    onChangeETSSponsorship(details) {
      this.enrolledInSpecialPrograms.etsSponsorship = parseInt(
        details.$event.id
      );
    }
    onChangeCurrentLocation(autoComplete) {
      const place = autoComplete.getPlace();
      const addressDetails = this.googleLocationService._formatAddress(place);
      this.$timeout(() => {
        this.formattedCurrentLocation = `${addressDetails.cityName}, ${addressDetails.stateCode}`;
      });
      this.details.currentLocation = addressDetails;
    }
    onPhoneNumberUpdate(details) {
      this.phoneNumberDetails = details;
    }
    onSubmit() {
      this.UserService.updateMemberDetails(this.$stateParams.id, {
        rankId: this.details.rankId,
        batchServiceId: this.details.batchServiceId,
        militaryOccupation: this.details.militaryOccupation,
        startDateOfService: this.startDateOfService.selectedDate,
        dutyLocation: this.details.dutyLocation,
        phoneDialCode: this.phoneNumberDetails.phoneDialCode,
        phoneCountryCode: this.phoneNumberDetails.phoneCountryCode,
        phoneNumber: this.phoneNumberDetails.phoneNumber,
        dob: this.dob.selectedDate,
        department: this.details.department,
        status: this.details.status,
        preferredLocation: this.details.preferredLocations.map((location) => ({
          name: location.name,
          details: location.details,
        })),
        maritalStatus:
          this.selectedMaritalStatusId === 1 ? "single" : "married",
        subscribeToWeeklyNewsletter: this.details.subscribeToWeeklyNewsletter,
        enrolledInSpecialPrograms: this.getSpecialProgramsBooleanValue(
          this.enrolledInSpecialPrograms
        ),
        linkedInProfile: this.details.linkedInProfile,
        currentLocation: this.details.currentLocation,
        selectedCMVRCenterId: this.details.cmvrCenterDetails
          ? this.details.cmvrCenterDetails.cmvrCenterId
          : null,
      })
        .then(() => {
          this.toastr.success("Member details updated successfully");
          // redirect to the members list route
          this.$state.go("userDetail", { id: this.$stateParams.id });
        })
        .catch((error) => {
          this.toastr.error(error);
        });
    }
    onCancel() {
      this.$state.go("userDetail", { id: this.$stateParams.id });
    }
    disableInputBox(email) {
      if (email !== "") {
        this.disableInput = true;
      }
    }
    getYesNoId(value) {
      if (value !== null) {
        return value ? 1 : 2;
      }
      return null;
    }
    getYesNoBooleanValue(value) {
      if (value !== null) {
        return value === 1 ? true : false;
      }
      return null;
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/user/user-edit/user-edit.component.js